import { Box, Fab, Tooltip, Zoom } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "../../../config/constants";
import { useCartStore } from "../../../store/useCartStore";

import CartIcon from "./CartIcon";

interface FloatingCartIconProps {
  onClick?: () => void;
}

const FloatingCartIcon: React.FC<FloatingCartIconProps> = ({ onClick }) => {
  const navigate = useNavigate();
  const { t: myTranslate } = useTranslation();
  const { getItemCount } = useCartStore();
  const itemCount = getItemCount();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate(ROUTES.CART);
    }
  };

  // Only show if there are items in cart
  if (itemCount === 0) {
    return null;
  }

  return (
    <Zoom in={itemCount > 0}>
      <Box
        sx={{
          position: "fixed",
          bottom: 80, // Above mobile nav
          right: 16,
          zIndex: 1000,
        }}
      >
        <Tooltip
          title={myTranslate("cart.viewCartItems", { count: itemCount })}
          placement="left"
        >
          <Fab
            color="primary"
            size="medium"
            onClick={handleClick}
            sx={{
              backgroundColor: "#ffd814",
              color: "#000",
              "&:hover": {
                backgroundColor: "#f7ca00",
              },
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
              mr: 0,
            }}
          >
            <CartIcon size="small" showTooltip={false} variant="icon" />
          </Fab>
        </Tooltip>
      </Box>
    </Zoom>
  );
};

export default FloatingCartIcon;
